import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

/*
 * Takes a boolean and returns translated Yes (i.e. true), No (i.e. false) and Unknown (i.e. null)
 */
@Pipe({ name: "booleanToYesNo" })
export class BooleanToYesNoPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: boolean): string {
    switch (value) {
      case true: {
        return this.translate.instant("YES_NO_UNKNOWN_PIPE.YES");
      }
      case false: {
        return this.translate.instant("YES_NO_UNKNOWN_PIPE.NO");
      }
      case null: {
        return this.translate.instant("YES_NO_UNKNOWN_PIPE.UNKNOWN");
      }
      default: {
        return this.translate.instant("YES_NO_UNKNOWN_PIPE.UNKNOWN");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/boolean-to-yes-no.pipe.ts